<template>
<div>
	<b-navbar class="submenu">
		<b-container>
			<b-navbar-brand href="#">Merchants Admin</b-navbar-brand>
			<b-collapse id="nav-collapse-sub" is-nav>
				<b-navbar-nav>
					<a href="#" @click="newMerchant()">New Merchant</a>
					<a href="#" @click="saveMerchant()" v-if="merchant">Save</a>
					<a href="#" @click="deleteMerchant()" v-if="merchant">Delete</a>
					<a href="#" @click="onLoad()" v-if="merchant">Reload</a>
				</b-navbar-nav>
			</b-collapse>
		</b-container>
	</b-navbar>
	<div id="content">
		<div class="row">
			<div class="col-md-3">
				<b-form-input placeholder="search" class="mb-2" v-model="search"></b-form-input>
				<div class="leftSide">
					<b-table :filter="search" striped hover small :items="merchants" selectable select-mode="single" :fields="['merchants']" @row-clicked="selectMerchant"></b-table>
				</div>
			</div>
			<div class="col-md-8 m-3 mt-0" v-if="merchant">
				<div class="row mb-2">
					<h4>{{merchant.id}}</h4>
				</div>
				<div class="row mb-2">
					<div class="col-md-4">
						Name: <b-form-input class="mb-2" v-model="merchant.name"></b-form-input>
					</div>
					<div class="col-md-4">
						Regex: <b-form-input class="mb-2" v-model="merchant.regex"></b-form-input>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-md-4">
						Lower Limit: <b-form-input class="mb-2" v-model="merchant.lowerLimit"></b-form-input>
					</div>
					<div class="col-md-4">
						Upper Limit: <b-form-input class="mb-2" v-model="merchant.upperLimit"></b-form-input>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-md-4">
						Utility: <b-form-checkbox class="mb-2" v-model="merchant.utilityProvider"></b-form-checkbox>
					</div>
					<div class="col-md-4">
						Switch Deal Available: <b-form-checkbox class="mb-2" v-model="merchant.switchDealAvailable"></b-form-checkbox>
					</div>
				</div>
				<div class="row mb-2">
					<div class="col-md-4">
						Cash Back Available: <b-form-checkbox class="mb-2" v-model="merchant.cashbackAvailable"></b-form-checkbox>
					</div>
					<div class="col-md-4">
						Voucher Available: <b-form-checkbox class="mb-2" v-model="merchant.voucherAvailable"></b-form-checkbox>
					</div>
				</div>
				
				<b-row>
					<b-col>
						Classification: 
					</b-col>
				</b-row>
				<div class="row mb-2">
					<div class="col-md-7" v-if="merchant.transactionClassification">
						<b-form-input readonly class="mb-2" v-model="merchant.transactionClassification.fullName"></b-form-input>
					</div>
					<div class="col-md-1">
						<b-button v-b-toggle.classificationsSidebar size="sm">Classify</b-button>
					</div>
				</div>

				<b-button v-if="!showDiscount && merchant && merchant.id" @click="showDiscount=true" size="sm">Add Discount</b-button>

				<div class="row" v-if="showDiscount">
					<b-col cols="7">
						Discount Percentage: <b-form-input class="mb-2" v-model="merchantDiscountRequest.discountPercentage"></b-form-input>
					</b-col>
					<b-col cols="1">
						<br/>
						<b-button @click="saveDiscount">Apply</b-button>
					</b-col>
				</div>

				<b-sidebar id="classificationsSidebar" class="sidebar" title="Classifications" bg-variant="dark" right shadow>
					<div class="px-3 py-2">
						
						<div v-for="p in transactionClassifications" :key="p.id">
							<b-button v-b-modal.modal-confirm @click="catClicked(p)" class="parent-cat">{{p.mgClassification.mgClassification}}</b-button>
							<b-button v-b-modal.modal-confirm @click="catClicked(c)" class="child-cat" size="sm" v-for="c in p.children" :key="c.mgClassification.id">{{c.mgClassification.mgSubClassification}}</b-button>
						</div>
						
					</div>
				</b-sidebar>

			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
  name: 'Merchants',
  data() {
	return{
		merchants: null,
		merchant: null,
		discounts: null,
		transactionClassifications: null,
		search: "",
		showDiscount: false,
		merchantDiscount: null,
		merchantDiscountRequest: { merchantName: "", discountPercentage: 0, sysoMerchantId: null }
	}
  },
  methods: {
	list: function(){
		this.$http.get(this.$config.ApiUri + "/Merchants")
			.then((result) => {
				this.merchants = result.data;
				for (var x = 0; x< this.merchants.length; x++)
				{
					this.merchants[x].merchants = this.merchants[x].name;
				}
			}
		)
	},
	catClicked: function(sel){
		this.merchant.transactionClassification = sel.mgClassification;
		this.$forceUpdate();
		this.merchant.setTransactionClassificationID = sel.mgClassification.id;
	},
	onLoad() {
		this.list();
		this.getTransactionClassifications();
		this.getDiscounts();
	},
	saveMerchant(){
		if (!this.merchant.switchDealAvailable) { this.merchant.switchDealAvailable = false; }
		if (!this.merchant.voucherAvailable) { this.merchant.voucherAvailable = false; }
		if (!this.merchant.cashbackAvailable) { this.merchant.cashbackAvailable = false; }
		if (!this.merchant.utilityProvider) { this.merchant.utilityProvider = false; }
		if (this.merchant.id != null) {
			this.$http.put(this.$config.ApiUri + "/Merchants/" + this.merchant.id, this.merchant)
				.then((result) => {
					this.merchant = result.data;
				}
			)
		} else {
			this.$http.post(this.$config.ApiUri + "/Merchants", this.merchant)
				.then((result) => {
					this.merchant = result.data;
					this.list();
				}
			)
		}
	},
	saveDiscount() {
		this.merchant.discountPercentage = this.merchantDiscountRequest.discountPercentage;
		this.$http.post(this.$config.ApiUri + "/Discounts", this.merchantDiscountRequest)
			.then(() => {
				this.getDiscounts();
				this.list();
			}
		)
	},
	deleteMerchant(){
		this.$http.delete(this.$config.ApiUri + "/Merchants/" + this.merchant.id)
			.then(() => {
				this.list();
				this.merchant = null;
				if (this.merchants.length > 0){
					this.selectMerchant(this.merchants[0]);
				}
			}
		)
	},
	newMerchant(){
		this.merchant = {
			name: "",
			regex: "",
			setTransactionClassificationID: null,
			upperLimit: null,
			lowerLimit: null,
			utilityProvider: false
		}
		this.showDiscount = false;
	},
	selectMerchant(e){
		this.merchant = e;
		this.merchantDiscountRequest.merchantName = this.merchant.name;
		this.merchantDiscountRequest.sysoMerchantId = this.merchant.id;
		this.findSelectedMerchantDiscount();
	},
	findSelectedMerchantDiscount(){
		if (this.discounts) {
			for (var x = 0; x < this.discounts.length; x++) {
				if (this.discounts[x].merchant.sysoMerchantId == this.merchant.id) {
					this.merchantDiscount = this.discounts[x];
					this.merchantDiscountRequest.discountPercentage = this.merchantDiscount.discountPercentage;
					this.showDiscount = true;
					return;
				}
			}
		}
		this.merchantDiscountRequest.discountPercentage = 0;
		this.showDiscount = false;
	},
	getTransactionClassifications(){
		this.$http.get(this.$config.ApiUri + "/TransactionClassifications")
			.then((result) => {
				this.transactionClassifications = result.data;
			}
		)
	},
	getDiscounts(){
		this.$http.get(this.$config.ApiUri + "/Discounts")
			.then((result) => {
				this.discounts = result.data;
			}
		)
	},
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style scoped="true">
	.child-cat {
		margin:3px;
		background-color: rgb(104, 84, 150);
	}
	.parent-cat {
		margin:3px;
		background-color: rgb(53, 43, 77);
	}

</style>